import { useState, useEffect } from 'react';
import { useAuthStore } from '@/stores/authStore';

export function SystemTray() {
  const [time, setTime] = useState(new Date());
  const { profile } = useAuthStore();

  useEffect(() => {
    const timer = setInterval(() => {
      setTime(new Date());
    }, 1000);

    return () => clearInterval(timer);
  }, []);

  const formatTime = (date: Date) => {
    return date.toLocaleTimeString('en-US', {
      hour: 'numeric',
      minute: '2-digit',
      hour12: true,
    });
  };

  return (
    <div className="bg-[#808080] border border-[#404040] px-3 py-1 flex items-center gap-3 text-xs font-mono text-black">
      {profile?.username && (
        <span className="flex items-center gap-1">
          <span>👤</span>
          {profile.username}
        </span>
      )}
      <span>{formatTime(time)}</span>
    </div>
  );
}
